import { BaseModel } from "@blue-chip/core";
import Vendor from "./Vendor";

export default class VendorCategory extends BaseModel {
  static get belongsTo() {
    return [Vendor];
  }
}
